import React from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { PageHeader, Input, Button, Card } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Table from "./Table";
import { SET_APP, GET_CALENDARS } from "@/actions/app";
import "./index.less";

const Screen = (props) => {
  const { data, history, loading } = props;

  const onCreate = () => {
    history.push("/calendars/new");
  };

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(SET_APP(["calendar"], null));
    dispatch(GET_CALENDARS());
  }, [dispatch]);

  const backUrl = localStorage.getItem("backUrl");

  return (
    <>
      <PageHeader
        title="Список календарных интервалов"
        subTitle={<SearchInput />}
        onBack={() => history.push(backUrl ? backUrl : "/campaings")}
        extra={[
          <Button key="create" type="success" onClick={onCreate}>
            Создать календарный интервал
          </Button>,
        ]}
      />
      <Card bordered={false}>
        <Table dataSource={data} loading={loading} history={props.history} />
      </Card>
    </>
  );
};

const SearchInput = () => (
  <Input
    placeholder="Поиск"
    suffix={<SearchOutlined className="search-icon" />}
  />
);

const mapStateToProps = (state) => ({
  data: state.app.calendars,
  loading: state.app.calendarsLoading,
});

export default connect(mapStateToProps)(Screen);
